<!-- <router-outlet></router-outlet> -->
<div id="all" class="fullHD roboto" *ngIf="datas && (!isVP)">
  <div class="boxes" *ngIf="!isVP">
    <a *ngFor="let box of boxes; let i=index;" (click)="onClick(box)" (mouseover)='onHover(box)' (mouseout)='onHover(box)'[class.hide]="box.hide" [ngStyle]="{
      'left': -60+120*box.col+'px',
      'top': -60+120*box.row+'px',
      'background-color': box.color,
      'transform-origin': box.origin,
      'transform': 'scale('+box.scale+')'
    }"><div class="table"><div class="cell"><span [innerHTML]="box.quote.quote" class="quote"></span><span [innerHTML]="box.quote.author" class="author suburban"></span></div></div></a>
    <!-- <div class="frame"></div> -->
  </div>
</div>
